import request from "../../../utils/request";
const { swSewagePath } = window.globalConfig;
export default class CustomerApi {

  /**
     * 大屏 站点列表
     * @param params
     * @returns {*|Promise<*>}
     */
  static selectGisStationList = (params) => {
    return request.post(
      `/${swSewagePath}/api/bigScreen/selectGisStationList`,
      params
    );
  };
  /**
     * 大屏  站点 水质数据
     * @param params
     * @returns {*|Promise<*>}
     */
  static selectGisStationWaterQuality = (params) => {
    return request.post(
      `/${swSewagePath}/api/bigScreen/selectGisStationWaterQuality`,
      params
    );
  };
  /**
     * 大屏 厂站设计/生产指标
     * @param params
     * @returns {*|Promise<*>}
     */
  static stationDesignOrProdQuota = (params) => {
    return request.post(
      `/${swSewagePath}/api/bigScreen/stationDesignOrProdQuota`,
      params
    );
  };
  /**
     * 大屏 厂站出水水质实时数据
     * @param params
     * @returns {*|Promise<*>}
     */
  static stationOutWaterQuality = (params) => {
    return request.post(
      `/${swSewagePath}/api/bigScreen/stationOutWaterQuality`,
      params
    );
  };
  /**
     * 大屏 进出水水量/能耗统计
     * @param params
     * @returns {*|Promise<*>}
     */
  static handleWaterAndDnb = (params) => {
    return request.post(
      `/${swSewagePath}/api/bigScreen/handleWaterAndDnb`,
      params
    );
  };
  /**
     * 大屏 信息总览-出水信息
     * @param params
     * @returns {*|Promise<*>}
     */
  static outWater = (params) => {
    return request.post(
      `/${swSewagePath}/api/bigScreen/outWater`,
      params
    );
  };
  /**
     * 大屏 厂站水质达标趋势图
     * @param params
     * @returns {*|Promise<*>}
     */
  static stationWaterQualityQualified = (params) => {
    return request.post(
      `/${swSewagePath}/api/bigScreen/stationWaterQualityQualified`,
      params
    );
  };
  /**
     * 大屏  厂站能耗数据分析
     * @param params
     * @returns {*|Promise<*>}
     */
  static selectDnbSurface = (params) => {
    return request.post(
      `/${swSewagePath}/api/bigScreen/selectDnbSurface`,
      params
    );
  };
  /**
     * 大屏  监控
     * @param params
     * @returns {*|Promise<*>}
     */
  static findCameraByStationId = (params) => {
    return request.post(
      `/${swSewagePath}/api/bigScreen/findCameraByStationId`,
      params
    );
  };
  /**
   * 大屏 获取DMA设备相关信息
   * @param params
   * @returns {*|Promise<*>}
   */
  static getDeviceInfoById = (params) => {
    return request.post(
      `/${window.scadaContentPath}/api/0/app/dma/getDeviceInfoById`,
      params
    );
  };

  /**
   * 大屏 scada数据展示
   * @param params
   * @returns {*|Promise<*>}
   */
  static findDeviceVOByTime = (params) => {
    return request.post(
      `/${window.scadaContentPath}/api/0/app/scada/findDeviceVOByTime`,
      params
    );
  };

  /**
   * 大屏 平均压力
   * @param params
   * @returns {*|Promise<*>}
   */
  static getPressure = (params) => {
    return request.post(
      `/${window.scadaContentPath}/api/0/app/rtw/getPressure`,
      params
    );
  };

  /**
   * 大屏 抄表
   * @param params
   * @returns {*|Promise<*>}
   */
  static getMeterReadingSta = (params) => {
    return request.post(
      `/${window.scadaContentPath}/api/0/app/rtw/getMeterReadingSta`,
      params
    );
  };

  /**
   * 大屏 大表监测
   * @param params
   * @returns {*|Promise<*>}
   */
  static getBigMeterSta = (params) => {
    return request.post(
      `/${window.scadaContentPath}/api/0/app/rtw/getBigMeterSta`,
      params
    );
  };

  /**
   * 大屏 大表监测
   * @param params
   * @returns {*|Promise<*>}
   */
  static getChargeDateVO = (params) => {
    return request.post(
      `/${window.scadaContentPath}/api/0/app/rev/getChargeDateVO`,
      params
    );
  };

  /**
   * 大屏 二供
   * @param params
   * @returns {*|Promise<*>}
   */
  static findSecSupplyData = (params) => {
    return request.post(
      `/${window.scadaContentPath}/api/0/app/sec/findSecSupplyData`,
      params
    );
  };
  /**
   * 大屏 微信
   * @param params
   * @returns {*|Promise<*>}
   */
  static findWxUserByDate = (params) => {
    return request.post(
      `/${window.scadaContentPath}/api/0/wetchatAnalysis/findWxUserByDate`,
      params
    );
  };
  /**
   * 大屏 管网数据--chart
   * @param params
   * @returns {*|Promise<*>}
   */
  static pipelineAssetsStatistics = (params) => {
    return request.post(
      `/${window.gisContentPath}/api/0/statistic/pipelineAssetsStatistics`,
      params
    );
  };
  /**
   * 大屏 管网数据--统计
   * @param params
   * @returns {*|Promise<*>}
   */
  static pipelineAssetsNum = (params) => {
    return request.post(
      `/${window.gisContentPath}/api/0/statistic/pipelineAssetsNum`,
      params
    );
  };
  /**
   * 大屏 用户统计
   * @param params
   * @returns {*|Promise<*>}
   */
  static customerStatistics = (params) => {
    return request.post(
      `/${window.scadaContentPath}/api/0/app/revenue/customerStatistics`,
      params
    );
  };
  /**
   * 大屏 7天收费情况
   * @param params
   * @returns {*|Promise<*>}
   */
  static chargeLast7Days = (params) => {
    return request.post(
      `/${window.scadaContentPath}/api/0/app/revenue/chargeLast7Days`,
      params
    );
  };

  /**
   * 大屏 告警-漏损
   * @param params
   * @returns {*|Promise<*>}
   */
  static findDMAInfo = (params) => {
    return request.post(
      `/${window.scadaContentPath}/api/0/app/dma/findDMAInfo`,
      params
    );
  };
  /**
   * 大屏 DMA
   * @param params
   * @returns {*|Promise<*>}
   */
  static findDMAListByType = (params) => {
    return request.post(
      `/${window.scadaContentPath}/api/0/app/dma/findDMAListByType`,
      params
    );
  }
  /**
   * 大屏 DMA--统计
   * @param params
   * @returns {*|Promise<*>}
   */
  static findDMACount = (params) => {
    return request.post(
      `/${window.scadaContentPath}/api/0/app/dma/findDMACount`,
      params
    );
  };

  /**
   * 大屏 DMA--设备信息
   * @param params
   * @returns {*|Promise<*>}
   */
  static getDMAInfoByName = (params) => {
    return request.post(
      `/${window.scadaContentPath}/api/0/app/dma/getDMAInfoByName`,
      params
    );
  };
  /**
   * 大屏 监控点信息
   * @param params
   * @returns {*|Promise<*>}
   */
  static getInfoBySn = (params) => {
    return request.post(
      `/${window.scadaContentPath}/api/0/app/monitor/getInfoBySn`,
      params
    );
  };
  /**
   * 大屏 DMA-一级-分区
   * @param params
   * @returns {*|Promise<*>}
   */
  static getDMA1 = () => {
    return request.get(
      `/${window.DMAURL[0]}`,
    );
  };
  /**
   * 大屏 DMA-2级-分区
   * @param params
   * @returns {*|Promise<*>}
   */
  static getDMA2 = () => {
    return request.get(
      `/${window.DMAURL[1]}`,
    );
  };
  /**
   * 大屏 DMA-3级-分区
   * @param params
   * @returns {*|Promise<*>}
   */
  static getDMA3 = () => {
    return request.get(
      `/${window.DMAURL[2]}`,
    );
  };
  /**
   * 大屏 DMA-4级-分区
   * @param params
   * @returns {*|Promise<*>}
   */
  static getDMA4 = () => {
    return request.get(
      `/${window.DMAURL[3]}`,
    );
  };

  /**
   * 大屏 水管
   * @param params
   * @returns {*|Promise<*>}
   */
  static waterpipeMap = () => {
    return request.get(
      `arcgis/rest/services/mz/netlayers2/MapServer/1/query?where=id%3E0&outFields=dev_id%2Ccode&geometryType=esriGeometryEnvelope&returnExtentsOnly=false&f=geojson`,
    );
  };
  /**
   * 大屏 监控点
   * @param params
   * @returns {*|Promise<*>}
   */
  static monitorMap = () => {
    return request.get(
      `arcgis/rest/services/mz/jiliangdian/MapServer/0/query?where=tpl_type_id%3D108&text=&objectIds=&time=&geometry=&geometryType=esriGeometryEnvelope&inSR=&spatialRel=esriSpatialRelIntersects&relationParam=&&outFields=dev_id%2Ccode%2Cwarring_flag&returnGeometry=true&returnTrueCurves=false&maxAllowableOffset=&geometryPrecision=&outSR=&returnIdsOnly=false&returnCountOnly=false&orderByFields=&groupByFieldsForStatistics=&outStatistics=&returnZ=false&returnM=false&gdbVersion=&returnDistinctValues=false&resultOffset=&resultRecordCount=&queryByDistance=&returnExtentsOnly=false&datumTransformation=&parameterValues=&rangeValues=&f=geojson`
      // `arcgis/rest/services/mz/jiliangdian/MapServer/0/query?where=id%3E0&text=&objectIds=&time=&geometry=&geometryType=esriGeometryEnvelope&inSR=&spatialRel=esriSpatialRelIntersects&relationParam=&outFields=dev_id%2Ccode&returnGeometry=true&returnTrueCurves=false&maxAllowableOffset=&geometryPrecision=&outSR=&returnIdsOnly=false&returnCountOnly=false&orderByFields=&groupByFieldsForStatistics=&outStatistics=&returnZ=false&returnM=false&gdbVersion=&returnDistinctValues=false&resultOffset=&resultRecordCount=&queryByDistance=&returnExtentsOnly=false&datumTransformation=&parameterValues=&rangeValues=&f=geojson`,
    );
  };
  /**
   * 大屏 消防栓
   * @param params
   * @returns {*|Promise<*>}
   */
  static plugMap = () => {
    return request.get(
      `arcgis/rest/services/mz/xfs/MapServer/0/query?where=id%3E0&text=&objectIds=&time=&geometry=&geometryType=esriGeometryEnvelope&inSR=&spatialRel=esriSpatialRelIntersects&relationParam=&outFields=dev_id&returnGeometry=true&returnTrueCurves=false&maxAllowableOffset=&geometryPrecision=&outSR=&returnIdsOnly=false&returnCountOnly=false&orderByFields=&groupByFieldsForStatistics=&outStatistics=&returnZ=false&returnM=false&gdbVersion=&returnDistinctValues=false&resultOffset=&resultRecordCount=&queryByDistance=&returnExtentsOnly=false&datumTransformation=&parameterValues=&rangeValues=&f=geojson`,
    );
  };
  /**
   * 大屏 阀门
   * @param params
   * @returns {*|Promise<*>}
   */
  static famengMap = () => {
    return request.get(
      `arcgis/rest/services/mz/valves/MapServer/0/query?where=id%3E0&text=&geometryType=esriGeometryEnvelope&inSR=&spatialRel=esriSpatialRelIntersects&outFields=dev_id&returnGeometry=true&returnTrueCurves=false&returnIdsOnly=false&returnCountOnly=false&orderByFields=&groupByFieldsForStatistics=&outStatistics=&returnZ=false&returnM=false&gdbVersion=&returnDistinctValues=false&resultOffset=&resultRecordCount=&queryByDistance=&returnExtentsOnly=false&datumTransformation=&parameterValues=&rangeValues=&f=geojson`,
    );
  };

  /**
   * 大屏 水厂工艺
   * @param params
   * @returns {*|Promise<*>}
   */
  static findWaterPlantsData = () => {
    return request.post(
      `/${window.scadaContentPath}/api/0/app/waterPlants/findWaterPlantsData`
    );
  };
  /**
   * 大屏 水厂数据
   * @param params
   * @returns {*|Promise<*>}
   */
  static findWaterSupplyPerDay = () => {
    return request.post(
      `/${window.scadaContentPath}/api/0/app/waterPlants/findWaterSupplyPerDay`
    );
  };



}
